import React, { useEffect } from "react";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/react-hooks";
import { POST_VAX_WALLET_PASS } from "../../queries";
import { useConsumerAuth } from "../../hooks/useConsumerAuth";
import { ReactComponent as AddToAppleWallet } from "../../images/Add_to_Apple_Wallet_rgb_US-UK.svg";
import { ReactComponent as AddToAndroidPay } from "../../images/Save_to_Google_Pay_dark_US-UK.svg";

const VaxWalletPass = ({ type }) => {
  const {
    first_name,
    last_name,
    dob,
    phone_number,
    session_token
  } = useConsumerAuth();

  const [postVaxWalletpass, { loading }] = useMutation(POST_VAX_WALLET_PASS, {
    onCompleted: ({ walletPass }) => {
      if (!walletPass || !walletPass.results) {
        return;
      }

      if (type == "ib") {
        window.location.replace(walletPass.results[walletPass.results.length - 1]);
      } else {
        window.location.replace(walletPass.results[0]);
      }
    }
  });

  const generateWalletPass = () => {
    let p_type = ''
    if (type === 'ip' || type === 'ib') {
      p_type = 'i';
    }
    postVaxWalletpass({
      variables: {
        body: {
          phone_number,
          dob,
          first_name,
          last_name,
          token: session_token,
          p_type
        }
      }
    });
  };

  return (
    <Button onClick={() => generateWalletPass()} disabled={loading}>
      {(type === "ip" || type === "ib") && <AddToAppleWallet />}
      {type === "a" && <AddToAndroidPay />}
    </Button>
  );
};

VaxWalletPass.propTypes = {
  type: PropTypes.oneOf(["a", "ip", "ib"]).isRequired
};

export { VaxWalletPass };
